import React, { useState } from 'react';
import { Package, ClipboardList, Inbox, LayoutDashboard, BarChart3, Tag } from 'lucide-react';
import { Link } from 'react-router-dom';
import { AdminProducts } from './AdminProducts';
import { AdminOrders } from './AdminOrders';
import { AdminDashboard } from './AdminDashboard';
import { AdminDiscounts } from './AdminDiscounts';

const AdminPage = () => {
  const [tab, setTab] = useState('dashboard');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-[#001B2A] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <h1 className="text-3xl font-serif font-bold flex items-center gap-3">
            <LayoutDashboard className="h-8 w-8" />
            Admin Dashboard
          </h1>
          <p className="text-white/70 mt-1">Manage products and orders for The Bow Tie Guy</p>
          <div className="flex flex-wrap gap-2 mt-6">
            <button
              data-testid="admin-tab-dashboard"
              onClick={() => setTab('dashboard')}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm transition-colors ${
                tab === 'dashboard' ? 'bg-[#7B1E2B] text-white' : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
            >
              <BarChart3 className="h-4 w-4" /> Dashboard
            </button>
            <button
              data-testid="admin-tab-products"
              onClick={() => setTab('products')}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm transition-colors ${
                tab === 'products' ? 'bg-[#7B1E2B] text-white' : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
            >
              <Package className="h-4 w-4" /> Products
            </button>
            <button
              data-testid="admin-tab-orders"
              onClick={() => setTab('orders')}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm transition-colors ${
                tab === 'orders' ? 'bg-[#7B1E2B] text-white' : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
            >
              <ClipboardList className="h-4 w-4" /> Orders
            </button>
            <button
              data-testid="admin-tab-discounts"
              onClick={() => setTab('discounts')}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm transition-colors ${
                tab === 'discounts' ? 'bg-[#7B1E2B] text-white' : 'bg-white/10 text-white/80 hover:bg-white/20'
              }`}
            >
              <Tag className="h-4 w-4" /> Discounts
            </button>
            <Link
              to="/submissions"
              data-testid="admin-link-submissions"
              className="flex items-center gap-2 px-5 py-2.5 rounded-md font-semibold text-sm bg-white/10 text-white/80 hover:bg-white/20 transition-colors"
            >
              <Inbox className="h-4 w-4" /> Design Submissions
            </Link>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {tab === 'dashboard' ? <AdminDashboard /> : tab === 'products' ? <AdminProducts /> : tab === 'discounts' ? <AdminDiscounts /> : <AdminOrders />}
      </div>
    </div>
  );
};

export default AdminPage;
